import React from "react";
import styles from './styles';
import URLS from '../../../config/navigation';
import SettingsMobileItem from "../SettingsMobileItem";
import {logout} from "../../../store/entities/Auth/Auth.actions";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import HelmetComponent from '../../Common/Helmet/'
const links = [
  {
    name: 'Edit profile',
    link: URLS.SETTINGS.EDIT
  },
  {
    name: 'Account Settings',
    link: URLS.SETTINGS.SETTINGS
  },
]

const SettingsMobileContainer = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className={"settingsMobileContainer"}>
       <HelmetComponent title="Settings - TeachOn"/>
      <div className={"headerContainer"}>
        <h1 className={"H1"}>Settings</h1>
      </div>
      <div className={"menuContainer"}>
        {
          links.map((item, index) => (
            <SettingsMobileItem key={index} name={item.name} link={item.link} />
          ))
        }
      </div>
      <div className={"logOutContainer"}>
        <span
          className={classes.logOutRow}
          onClick={() => dispatch(logout(() => history.push(URLS.AUTH.SIGNIN)))}
        >
          Log out
        </span>
      </div>
    </div>
  );
}

export default SettingsMobileContainer;
